import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CurrentUserAdapter} from '@drl/core/auth/adapters/current-user-adapter.service';
import {Role} from '@drl/core/store/models/role.model';
import {StoreKeys} from '@drl/core/store/store-keys.enum';
import {InMemoryStorageService} from 'angular-webstorage-service';
import {CareGroupWithMembers} from '../models';

@Injectable()
export class CareGroupWithMembersAdapter
  implements IAdapter<CareGroupWithMembers>
{
  constructor(
    private readonly userAdapter: CurrentUserAdapter,
    private readonly inMemoryStore: InMemoryStorageService,
  ) {}

  // sonarignore:start
  adaptToModel(resp: any): CareGroupWithMembers {
    // sonarignore:end
    const rolesInStore = this.inMemoryStore.get(StoreKeys.ROLES) as Role[];
    const cgWithMembers = new CareGroupWithMembers();
    cgWithMembers.caregroup = resp.caregroup;
    cgWithMembers.members = resp.members.map(member => {
      const m = this.userAdapter.adaptToModel(member);
      m.role = rolesInStore.find(r => m.roleId === r.id);
      return m;
    });
    return cgWithMembers;
  }

  // sonarignore:start
  adaptFromModel(data: CareGroupWithMembers): any {
    return data;
  }
  // sonarignore:end
}
